import { ActivityStatus, Priority } from '@kainos/shared';
import type { Activity } from '@kainos/validation';
import { DEMO_TENANT_ID } from './session.js';
import { daysAgo, hoursAgo } from './time.js';

const audit = {
  createdAt: daysAgo(60),
  createdBy: 'usr_daniela',
  updatedAt: daysAgo(1),
  updatedBy: 'usr_daniela',
};

/** The eight activities from the design, mapped onto the domain enums. */
export const DEMO_ACTIVITIES: Activity[] = [
  {
    ...audit,
    id: 'act_1',
    tenantId: DEMO_TENANT_ID,
    projectId: 'prj_plantanorte',
    phaseId: 'phs_ingenieria',
    title: 'Validación planos eléctricos',
    description:
      'Revisión y validación de planos eléctricos as-built con ingeniería de detalle antes de iniciar Construcción.',
    ownerId: 'usr_daniela',
    status: ActivityStatus.PENDING,
    priority: Priority.HIGH,
    progress: 40,
    dueDate: '2026-08-24',
    dependsOn: [],
    lastUpdateAt: daysAgo(3),
  },
  {
    ...audit,
    id: 'act_2',
    tenantId: DEMO_TENANT_ID,
    projectId: 'prj_montajeelectrico',
    phaseId: 'phs_construccion',
    title: 'Instalación tablero eléctrico',
    description:
      'Instalación y cableado del tablero eléctrico sector B, incluye montaje de sensores de temperatura y continuidad.',
    ownerId: 'usr_carlos',
    status: ActivityStatus.BLOCKED,
    priority: Priority.CRITICAL,
    progress: 55,
    dueDate: '2026-08-26',
    dependsOn: [],
    lastUpdateAt: daysAgo(2),
  },
  {
    ...audit,
    id: 'act_3',
    tenantId: DEMO_TENANT_ID,
    projectId: 'prj_plantanorte',
    phaseId: 'phs_construccion',
    title: 'Montaje piping línea 03',
    description:
      'Montaje de piping para línea de proceso 03, incluye soportería y pruebas de posicionamiento.',
    ownerId: 'usr_felipe',
    status: ActivityStatus.IN_PROGRESS,
    priority: Priority.MEDIUM,
    progress: 75,
    dueDate: '2026-08-29',
    dependsOn: [],
    lastUpdateAt: hoursAgo(2),
  },
  {
    ...audit,
    id: 'act_4',
    tenantId: DEMO_TENANT_ID,
    projectId: 'prj_plantanorte',
    phaseId: 'phs_construccion',
    title: 'Pruebas de continuidad',
    description:
      'Pruebas de continuidad eléctrica en tableros instalados, con registro fotográfico de resultados.',
    ownerId: 'usr_camila',
    status: ActivityStatus.IN_PROGRESS,
    priority: Priority.MEDIUM,
    progress: 60,
    dueDate: '2026-09-02',
    dependsOn: [],
    lastUpdateAt: hoursAgo(4),
  },
  {
    ...audit,
    id: 'act_5',
    tenantId: DEMO_TENANT_ID,
    projectId: 'prj_plantanorte',
    phaseId: 'phs_puestaenmarcha',
    title: 'Capacitación operadores',
    description: 'Capacitación de operadores de planta previa a puesta en marcha.',
    ownerId: 'usr_daniela',
    status: ActivityStatus.PENDING,
    priority: Priority.LOW,
    progress: 0,
    dueDate: '2026-11-10',
    dependsOn: [],
    lastUpdateAt: daysAgo(8),
  },
  {
    ...audit,
    id: 'act_6',
    tenantId: DEMO_TENANT_ID,
    projectId: 'prj_montajeelectrico',
    phaseId: 'phs_construccion',
    title: 'Pruebas de aislación eléctrica',
    description:
      'Pruebas de aislación sobre tablero eléctrico instalado, requiere que la instalación esté completa.',
    ownerId: 'usr_felipe',
    status: ActivityStatus.BLOCKED,
    priority: Priority.HIGH,
    progress: 30,
    dueDate: '2026-08-28',
    dependsOn: ['act_2'],
    lastUpdateAt: daysAgo(2),
  },
  {
    ...audit,
    id: 'act_7',
    tenantId: DEMO_TENANT_ID,
    projectId: 'prj_bodegacentral',
    title: 'Levantamiento de terreno bodega',
    description: 'Levantamiento topográfico y de terreno para ampliación de bodega central.',
    ownerId: 'usr_camila',
    status: ActivityStatus.DONE,
    priority: Priority.LOW,
    progress: 100,
    dueDate: '2026-08-15',
    dependsOn: [],
    lastUpdateAt: daysAgo(6),
  },
  {
    ...audit,
    id: 'act_8',
    tenantId: DEMO_TENANT_ID,
    projectId: 'prj_flotavehicular',
    title: 'Revisión eléctrica final flota',
    description: 'Revisión final del sistema eléctrico de la flota renovada.',
    ownerId: 'usr_carlos',
    status: ActivityStatus.DONE,
    priority: Priority.LOW,
    progress: 100,
    dueDate: '2026-06-20',
    dependsOn: [],
    lastUpdateAt: daysAgo(40),
  },
];

/** AI note attached to the activity the design highlights. */
export const DEMO_ACTIVITY_INSIGHT: Record<string, string> = {
  act_2:
    'KainOS detectó que esta actividad podría afectar el hito "Puesta en marcha" si el bloqueo por materiales no se resuelve en las próximas 48 horas.',
};
